// extracted by mini-css-extract-plugin
export var container = "_5c-0";
export var containerTopRight = "_5c-1";